export default __webpack_public_path__ + "static/media/NeedHelp@2x.8b8f41ec.png";